import React, { useEffect, useState } from "react";
import axios from "axios";
import BreadCrumb from "../Common/BreadCrumb";
import AddCourseModal from "../../Components/adminComponents/DashboardCoursesComponents/AddCourseModal";

const DashboardCourse = () => {
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // const fetchCourses = async () => {
  //   try {
  //     setLoading(true);
  //     setError("");
  //     const res = await axios.get("http://localhost:8000/api/course");
  //     const data = Array.isArray(res.data) ? res.data : res.data.courses || [];
  //     console.log(res);

  //     setCourses(data);
  //     setFilteredCourses(data);
  //   } catch (err) {
  //     console.error(err);
  //     setError("Failed to load courses. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getAllCourses = () => {
    setLoading(true);
    setError("");

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "http://localhost:8000/api/course",
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        setCourses(response.data);
        setFilteredCourses(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setError("Failed to load courses. Please try again.");
        setLoading(false);
      });
  };

  useEffect(() => {
    // fetchCourses();
    getAllCourses();
  }, []);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredCourses(courses);
    } else {
      const term = searchTerm.toLowerCase();
      setFilteredCourses(
        courses.filter((course) =>
          (course.title || course.name || "").toLowerCase().includes(term)
        )
      );
    }
  }, [searchTerm, courses]);

  const handleCourseAdded = (newCourse) => {
    setCourses((prev) => [newCourse, ...prev]);
    setIsAddModalOpen(false);
  };

  const getLevelClass = (level) => {
    if (!level) return "bg-emerald-50 text-emerald-700 border-emerald-200";
    if (level === "Beginner" || level === "Basic")
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    if (level === "Intermediate")
      return "bg-indigo-50 text-indigo-700 border-indigo-200";
    if (level === "Advanced")
      return "bg-amber-50 text-amber-700 border-amber-200";
    return "bg-slate-50 text-slate-700 border-slate-200";
  };

  return (
    <div className="min-h-screen bg-slate-100 px-4 py-4 sm:px-6 lg:px-8">
      <BreadCrumb title="Dashboard Course" trail={["Dashboard", "Course"]} />

      {/* Header */}
      <div className="mt-4 mb-6 flex flex-wrap items-start justify-between gap-4">
        <div>
          <h2 className="text-xl font-semibold text-slate-900 sm:text-2xl">
            Courses
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            Manage all your courses, create new ones, and keep everything
            organized.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="Search courses..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-56 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 shadow-sm outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 sm:w-64"
            />
            <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-xs text-slate-400">
              ⌕
            </span>
          </div>
          <button
            onClick={() => setIsAddModalOpen(true)}
            className="inline-flex items-center rounded-full bg-gradient-to-r from-indigo-600 to-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-md transition hover:-translate-y-0.5 hover:shadow-lg"
          >
            <span className="mr-1 text-lg leading-none">＋</span>
            <span>Add Course</span>
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="mb-6 grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <p className="text-xs font-medium uppercase tracking-wide text-slate-400">
            Total Courses
          </p>
          <p className="mt-1 text-2xl font-semibold text-slate-900">
            {courses.length}
          </p>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <p className="text-xs font-medium uppercase tracking-wide text-slate-400">
            Showing
          </p>
          <p className="mt-1 text-2xl font-semibold text-slate-900">
            {filteredCourses.length}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="space-y-4">
        {loading && (
          <div className="rounded-xl border border-indigo-100 bg-indigo-50 px-4 py-3 text-sm text-indigo-700">
            Loading courses...
          </div>
        )}

        {error && (
          <div className="rounded-xl border border-rose-100 bg-rose-50 px-4 py-3 text-sm text-rose-700">
            {error}
          </div>
        )}

        {!loading && !error && filteredCourses.length === 0 && (
          <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-12 text-center shadow-sm">
            <p className="text-sm text-slate-500">No courses found.</p>
            <button
              onClick={() => setIsAddModalOpen(true)}
              className="mt-4 inline-flex items-center rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm transition hover:border-indigo-400 hover:text-indigo-600"
            >
              Add your first course
            </button>
          </div>
        )}

        {!loading && !error && filteredCourses.length > 0 && (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {filteredCourses.map((course) => {
              const level = course.level || "Beginner";
              return (
                <div
                  key={course._id || course.id}
                  className="flex flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
                >
                  <div className="mb-2 flex items-start justify-between gap-2">
                    <h3 className="line-clamp-2 text-sm font-semibold text-slate-900">
                      {course.title || course.name || "Untitled Course"}
                    </h3>
                    <span
                      className={`whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${getLevelClass(
                        level
                      )}`}
                    >
                      {level}
                    </span>
                  </div>

                  <p className="mb-3 line-clamp-3 text-xs text-slate-500">
                    {course.description || "No description available."}
                  </p>

                  <div className="mt-auto flex flex-wrap items-center justify-between gap-2 border-t border-slate-100 pt-2">
                    <span className="text-[11px] text-slate-500">
                      Category:{" "}
                      <span className="font-medium text-slate-700">
                        {course.category || "General"}
                      </span>
                    </span>
                    <span className="text-[11px] text-slate-500">
                      Duration:{" "}
                      <span className="font-medium text-slate-700">
                        {course.duration || "Self-paced"}
                      </span>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Add Course Modal */}
      <AddCourseModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onCourseAdded={handleCourseAdded}
      />
    </div>
  );
};

export default DashboardCourse;
